import throttle from 'lodash/throttle';

export class PriorityPlusMenu {

    /**
     * @param {Object} obj - An object.
     * @param {Element} obj.toggle - The button to toggle the menu with.
     * @param {NodeList} obj.navItems - The items that need to disappear when they don't fit.
     */
    constructor({ toggle, navItems }) {
        if(!navItems.length) return new Error(`No nav items found.
        Not sure what you expect of me at this point.
        Please point me to your navigation items so I can figure out if they fit or not`);
		
		this.navItems = navItems;
        // Store container node for easy access
        this.container = navItems[0].parentNode;
        // Store toggle button. Ideally this functionality would be in a different class
        this.toggle = toggle;

        // Sort nav items based on display priority. 0 dissapears last
        // If data-priorty is not set on element, use index
        this.sortedNavItems = [...navItems].sort((navA, navB) => {
            const prioA = navA.dataset.priority;
            const prioB = navB.dataset.priority;

            return prioB - prioA;
        });


        this.addListeners();
        this.makeItFit();
    }

    get fits() {
        // Get the highest button in the menu
        const navItemHeight = Math.max(...[...this.navItems].map(nav => nav.clientHeight));
        const containerHeight = this.container.clientHeight;
       
        return containerHeight <= navItemHeight;
    }

    makeItFit() {
        this.sortedNavItems.forEach(nav => nav.classList.remove('is-hidden'));
        // Hide menu button first
        // this.toggle.classList.add('is-hidden');
        for(const navItem of this.sortedNavItems) {
            // Stop as soon as everything fits
            if(this.fits) break;
            // If not, hide nav elements
            navItem.classList.add('is-hidden');
            // And show menu button
            this.toggle.classList.remove('is-hidden');
        }
    }

    toggleMenu() {
        document.body.classList.toggle('is-nav_open');
    }

    addListeners() {
        window.addEventListener('resize', 
            throttle(this.makeItFit.bind(this))
        );
        // Ideally this would be in a different class
        this.toggle.addEventListener('click', this.toggleMenu);
    }
}
